import { Helmet } from 'react-helmet-async';
import React from 'react';
import UsersContainer from '../../../containers/organizations/UsersContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const Users = ({ slug }) => (
  <>
    <Helmet>
      <title>Users | ChangeSync</title>
    </Helmet>

    <UsersContainer slug={slug} />
  </>
);

Users.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(Users));
